import React from 'react';
import classnames from 'classnames';
import formatMoney from 'utils/formatters/Money';
import CircleCheckIcon from 'components/v2/icons/CircleCheckIcon';
import Tooltip from 'components/v2/Tooltip';
import { Translation } from 'react-i18next';
import CollapsibleItem from 'components/v2/list/CollapsibleItem';
const emailSent = (cell) => {
    return (React.createElement("div", { className: "text-green" }, cell && (React.createElement(Tooltip, { className: "w-5 h-5", body: () => React.createElement(CircleCheckIcon, { className: "text-green-cm h-5 w-5" }) },
        React.createElement(Translation, null, (t) => React.createElement("div", null, t('EMAIL_SENT_WITH_EXCLAMATION')))))));
};
const ediSent = (cell) => {
    return (React.createElement("div", { className: "text-green" }, cell && (React.createElement(Tooltip, { className: "w-5 h-5", body: () => React.createElement(CircleCheckIcon, { className: "text-green-cm h-5 w-5" }) },
        React.createElement(Translation, null, (t) => React.createElement("div", null, t('EDI_SENT_WITH_EXCLAMATION')))))));
};
const creditMemoSent = (cell) => {
    React.createElement("div", { className: "text-green" }, cell && (React.createElement(Tooltip, { className: "w-5 h-5", body: () => React.createElement(CircleCheckIcon, { className: "text-green-cm h-5 w-5" }) },
        React.createElement(Translation, null, (t) => React.createElement("div", null, t('CREDIT_MEMO_SENT_WITH_EXCLAMATION'))))));
};
const creditMemoFormatter = (cell, row) => {
    return (React.createElement("span", { className: classnames({ 'text-red-500': !!cell }) }, formatMoney(cell, row === null || row === void 0 ? void 0 : row.currency)));
};
const jobFormatter = (field) => (cell, row) => {
    if (field === 'shipment_id') {
        if (cell && cell.length) {
            return (React.createElement(CollapsibleItem, { renderTitle: () => (React.createElement(Translation, null, (t) => t('SHIPMENTS_NUMBER', { count: cell.length }))) }, cell.map((c) => (React.createElement("div", null,
                React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: `/shipments/${c._id}` }, c[field]))))));
        }
    }
    if (field === 'equipments') {
        if (cell && cell.length) {
            const numberOfEquipments = cell.reduce((acc, job) => {
                if (job[field] && job[field].length) {
                    return acc.concat(job[field]);
                }
                return acc;
            }, []);
            return (React.createElement(CollapsibleItem, { renderTitle: () => (React.createElement(Translation, null, (t) => t('EQUIPMENTS_NUMBER', { count: numberOfEquipments.length }))) }, numberOfEquipments.length ? (numberOfEquipments.map((equip) => (React.createElement("div", { className: "text-center !break-word" }, equip)))) : (React.createElement("div", { className: "text-center" },
                React.createElement(Translation, null, (t) => t('N_A'))))));
        }
        return (React.createElement("div", { className: "text-center" },
            React.createElement(Translation, null, (t) => t('N_A'))));
    }
    if (field === 'destination') {
        if (cell && cell.length) {
            let numberOfDestinations = [];
            if (cell.length === 1 &&
                cell.every((s) => (s === null || s === void 0 ? void 0 : s.shipment_type) === 'drayage')) {
                numberOfDestinations = cell.reduce((acc, job) => {
                    if (job[field] && job[field].length) {
                        const destinations = job[field].map((dst) => (dst === null || dst === void 0 ? void 0 : dst.name) || React.createElement(Translation, null, (t) => t('N_A')));
                        return acc.concat(destinations);
                    }
                    return acc;
                }, []);
            }
            else {
                numberOfDestinations = cell.reduce((acc, job) => {
                    if (job[field] && job[field].length) {
                        return acc + job[field].length;
                    }
                    return acc;
                }, 0);
            }
            const isDrayageShipments = Array.isArray(numberOfDestinations);
            const destinationCount = isDrayageShipments
                ? numberOfDestinations.length
                : numberOfDestinations;
            return (React.createElement(CollapsibleItem, { renderTitle: () => (React.createElement(Translation, null, (t) => t('DESTINATIONS_NUMBER', { count: destinationCount }))) }, isDrayageShipments ? (numberOfDestinations.map((dest) => (React.createElement("div", { className: "text-center whitespace-pre !break-word" }, dest)))) : (React.createElement("div", { className: "!break-word" }, destinationCount > 0 ? (React.createElement(Translation, null, (t) => t('REFER_INVOICE'))) : (React.createElement(Translation, null, (t) => t('N_A')))))));
        }
        return (React.createElement("div", { className: "" },
            React.createElement(Translation, null, (t) => t('N_A'))));
    }
};
export const columns = [
    {
        dataField: 'number',
        text: 'Invoice Number',
        localizationSlug: 'INVOICE_NUMBER',
        sort: true,
        type: 'entity',
        entityType: 'invoice',
        headerStyle: {
            width: '20%',
        },
    },
    {
        dataField: 'credit_memos[0].number',
        text: 'Credit Memo',
        localizationSlug: 'CREDIT_MEMO',
        sort: true,
        type: 'entity',
        entityType: 'invoice',
        headerStyle: {
            width: '20%',
        },
    },
    {
        dataField: 'jobs',
        text: 'Shipment ID',
        localizationSlug: 'SHIPMENT',
        formatter: jobFormatter('shipment_id'),
        headerStyle: {
            width: '20%',
        },
    },
    {
        dataField: 'jobs',
        text: 'Equipment ID',
        localizationSlug: 'EQUIPMENT',
        formatter: jobFormatter('equipments'),
        headerStyle: {
            width: '20%',
        },
    },
    {
        dataField: 'jobs',
        text: 'Destination',
        localizationSlug: 'DESTINATION',
        formatter: jobFormatter('destination'),
        headerStyle: {
            width: '20%',
        },
    },
    {
        dataField: 'date_created',
        text: 'INV Date Created',
        localizationSlug: 'INV_DATE_CREATED',
        type: 'datetime',
        sort: true,
    },
    {
        dataField: 'credit_memos[0].date_created',
        text: 'CM Date Created',
        localizationSlug: 'CM_DATE_CREATED',
        type: 'datetime',
        sort: true,
    },
    {
        dataField: 'shipper_name',
        text: 'Shipper',
        titleize: true,
        localizationSlug: 'SHIPPER',
        count: 1,
        sort: true,
    },
    {
        dataField: 'total',
        text: 'INV Total',
        localizationSlug: 'INVOICE_TOTAL',
        sort: true,
        type: 'currency',
    },
    {
        dataField: 'total_payments',
        text: 'Paid',
        localizationSlug: 'PAID',
        sort: true,
        type: 'currency',
    },
    {
        dataField: 'credit_memos[0].total',
        text: 'Credit',
        localizationSlug: 'CREDIT',
        sort: true,
        type: 'currency',
        formatter: creditMemoFormatter,
    },
    {
        dataField: 'amount_due',
        text: 'Balance',
        localizationSlug: 'BALANCE',
        sort: true,
        type: 'currency',
    },
    {
        dataField: 'email_sent',
        text: 'Invoice Email Sent',
        localizationSlug: 'INV_SENT',
        sort: true,
        formatter: emailSent,
    },
    {
        dataField: 'edi_sent',
        text: 'EDI Sent',
        localizationSlug: 'EDI_SENT',
        sort: true,
        formatter: ediSent,
    },
    {
        dataField: 'credit_memos[0].email_sent',
        text: 'CM Sent',
        localizationSlug: 'CREDIT_MEMO_SENT',
        sort: true,
        formatter: creditMemoSent,
    },
];
